<template>
    <div class="">
        <v-select
            :name="name"
            :clearable="false"
            label="text"
            :options="options"
            :placeholder="placeholder"
            class="v-select-user bg-white"
            @input="event => $emit('filtered', {[filterType] : event ? event.value : event})"/>
    </div>
</template>

<script>
    export default {
        name: 'TableSelectField',
        props: {
            name: {
                type: String,
                required: true
            },
            placeholder: {
                type: String,
                required: true
            },
            filterType: {
                type: String,
                required: true
            },
            options: {
                type: Array,
                default() {
                    return [
                        {
                            text: 'Default',
                            value: null
                        }
                    ]
                }
            }
        },
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/TableSelectField.vue